export const GLOBAL_LOGISTICS_RESET_STATE = 'GLOBAL_LOGISTICS_RESET_STATE';
export const GLOBAL_LOGISTICS_CURRENT_ITEM = 'GLOBAL_LOGISTICS_CURRENT_ITEM';

export const GLOBAL_LOGISTICS_REQUEST_LOADING = 'GLOBAL_LOGISTICS_REQUEST_LOADING';
export const GLOBAL_LOGISTICS_REQUEST_SUCCESS = 'GLOBAL_LOGISTICS_REQUEST_SUCCESS';
export const GLOBAL_LOGISTICS_REQUEST_FAILED = 'GLOBAL_LOGISTICS_REQUEST_FAILED';

export const GLOBAL_LOGISTICS_CURRENT_ACTION = 'GLOBAL_LOGISTICS_CURRENT_ACTION';
export const GLOBAL_LOGISTICS_RESET_ACTION = 'GLOBAL_LOGISTICS_RESET_ACTION';